<nav class="{{SideClass}}" #nav>
  <div [ngClass]="{'container': containerInside}" [ngStyle]="{'display': displayStyle}" #container>
    <ng-content select="logo"></ng-content>
    <ng-content *ngIf="this.doubleNav == true" select="navlinks"></ng-content>
    <div *ngIf="this.doubleNav == false">
      <button class="navbar-toggler" type="button" (click)="toggle($event)" mdbRippleRadius *ngIf="this.el.nativeElement.children.length !== 0">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div #navbar [style.height]="height" class="navbar-collapse collapse" [ngClass]="{'collapse': collapse, 'show': showClass, 'collapsing': collapsing}">
      <ng-content select="links"></ng-content>
    </div>
  </div>
</nav>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/navbars/navbar.component.html